'use client';

import TerminForm from '@/sections/forms/multistep-form/form/TerminForm';
import type { StepThreeTerminProps } from './types';

const FormStep: React.FC<StepThreeTerminProps> = ({
  form,
  hiddenFields,
  multistepConsultationTitle,
  multistepTopics,
  multistepAnliegen,
  onSubmitRef,
  onSubmitStart,
  onSuccess,
  onError,
  presetCallbackRequestNotes,
  presetWebsiteSelectedTopics,
}) => {
  const resolvedHiddenFields = hiddenFields ?? form?.hiddenFields;

  return (
    <TerminForm
      embeddedInMultistep
      onSubmitRef={onSubmitRef}
      onSubmitStart={onSubmitStart}
      onSuccess={onSuccess}
      onError={onError}
      multistepConsultationTitle={multistepConsultationTitle}
      multistepTopics={multistepTopics}
      multistepAnliegen={multistepAnliegen}
      hiddenFields={resolvedHiddenFields}
      sectionId={form?.sectionId}
      presetCallbackRequestNotes={presetCallbackRequestNotes}
      presetWebsiteSelectedTopics={presetWebsiteSelectedTopics}
    />
  );
};

export default FormStep;
